import Quill from 'quill';

const LinkBlot: any = Quill.import('formats/link');

class ClickableLink extends LinkBlot {
  static sanitize(url: string) {
    let sanitizedUrl = LinkBlot.sanitize(url);

    const protocolRegex = /^(https?|ftp|mailto|tel):/i;

    if (typeof sanitizedUrl === 'string' && !protocolRegex.test(sanitizedUrl) && !sanitizedUrl.startsWith('#')) {
      sanitizedUrl = `https://${sanitizedUrl}`;
    }

    return sanitizedUrl;
  }

  static create(value: string) {
    const node = super.create(value) as HTMLElement;
    node.setAttribute('contenteditable', 'false');

    return node;
  }
}

export default ClickableLink;
